import { render, staticRenderFns } from "./ChecklistsAddAction.vue?vue&type=template&id=8b6a44c2&scoped=true"
import script from "./ChecklistsAddAction.vue?vue&type=script&lang=js"
export * from "./ChecklistsAddAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6a44c2",
  null
  
)

export default component.exports